import { SET_AUTH_PROPERTY, NEW_DRIVER, SET_USER_INFO } from 'store/actions/auth';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_AUTH_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },
  [NEW_DRIVER]: (state, { driver }) => {
    state.newDriver = driver;
  },
  [SET_USER_INFO]: (state, userInfo) => {
    state.userInfo = userInfo;
  }
};
